import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import { toast } from 'react-toastify';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';

const CardForm = forwardRef((props, ref) => {
    const stripe = useStripe();
    const elements = useElements();
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSaveCard = async () => {
        if (!stripe || !elements) {
            toast.error("Stripe is not loaded yet");
            return null;
        }

        try {
            setIsProcessing(true);
            // Create payment method
            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: "card",
                card: elements.getElement(CardElement),
            });

            if (error) {
                toast.error(error.message);
                return null;
            }


            // Clear the card element
            elements.getElement(CardElement).clear();

            // Return the payment method ID
            return paymentMethod.id;
        } catch (error) {
            ErrorHandlingMessage(error);
            return null;
        } finally {
            setIsProcessing(false);
        }
    };

    // Expose handleSaveCard function to parent via ref
    useImperativeHandle(ref, () => ({
        handleSaveCard
    }));

    return (
        <div className={`w-full`}>
            {isProcessing && <FullPageLoader />}
            <CardElement
                options={{ classes: { base: "bg-gray-200/50 shadow-sm rounded-md p-2", }, hidePostalCode: true, disableLink: true }}
                id="payment-element"
            />
        </div>
    );
});

CardForm.displayName = 'CardForm';

const AddNewCardForm = forwardRef(({ publishableKey }, ref) => {
    const [stripePromise, setStripePromise] = useState(null);

    const options = {
        mode: "payment",
        amount: 1099,
        currency: "usd",
        appearance: {
            /*...*/
        },
    };

    useEffect(() => {
        (async () => {
            try {
                let stripePromise = await loadStripe(publishableKey);
                setStripePromise(stripePromise);
            } catch (error) {
                ErrorHandlingMessage(error);
            }
        })();
    }, [publishableKey]);

    return (
        <div>
            <div className={`w-full`}>
                {stripePromise && (
                    <Elements key={publishableKey} stripe={stripePromise} options={{ ...options, appearance: { theme: "flat" } }} >
                        <CardForm ref={ref} />
                    </Elements>
                )}
            </div>
        </div>
    )
});

AddNewCardForm.displayName = 'AddNewCardForm';

export default AddNewCardForm